
import React, { useEffect, useState} from "react";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';


export const Explanation = (props) =>{

    const [typeInstruction, setTypeInstructions] = useState("submitExperiments");

    useEffect(() => {        
        // 1. Get The type of experiments to Apply
        switch (window.location.hash){
            case "#/submitfiles":
                setTypeInstructions("submitFiles");
                break;
            case "#/submitexperiments":
                setTypeInstructions("submitExperiments");
                break;
            case "#/submissionexperimentclose":
                setTypeInstructions("submissionExperimentClose");
                break;
        }
    }, [])

    const getDialogTitle = () => {
        switch (typeInstruction){
            case "submitFiles":
                return "How to submit Files Metadata";
            case "submitExperiments":
                return "How to submit experiments";
            case "submissionExperimentClose":
                return "How to close experiment file submission";
        }
    }

    const fileSubmissionInstructions = () => {
        return (
            <div className={"explanation"}>
                To submit a single or multiple experiments, please enter the required information:
                <ul>
                    <li>RD Connect ID Experiment</li>
                    <li>File (FileName can't be edited)</li>
                    <li>Filetype</li>
                    <li>Sequency Strategy</li>
                </ul>
                Click the <strong>VALIDATE</strong> button to verify that data is ready for submission. Then click on <strong>SUBMIT</strong>. You can <strong>VALIDATE</strong> your data anytime during the submission.
                Please, keep in mind that you can't save a draft of your current submission. Also, leaving the page will cancel all your entries.
                <Divider/>
                <strong>Buttons +1, +10, +100 </strong> will add extra rows to the submission table. In case of Upload, you don't need to click on it.
            </div>
        );
    }

    const experimentSubmissionInstructions = () => {
        return (
            <div className={"explanation"}>
                To submit a single or multiple experiments, please enter the required information:
                <ul>
                    <li>Participant ID</li>
                    <li>Local Experiment ID</li>
                    <li>Project(s)</li>
                    <li>Month Until Embargo</li>
                    <li>ERNs</li>
                    <li>Tissue</li>
                    <li>Library Strategy</li>
                    <li>WGS/Exome Kit</li>
                    <li>Owner (select from dropdown)</li>
                </ul>
                Click the <strong>VALIDATE</strong> button to verify that data is ready for submission. Then click on <strong>SUBMIT</strong>. You can <strong>VALIDATE</strong> your data anytime during the submission.
                Please, keep in mind that you can't save a draft of your current submission. Also, leaving the page will cancel all your entries.
                <Divider/>
                <strong>Buttons +1, +10, +100 </strong> will add extra rows to the submission table. In case of Upload, you don't need to click on it.
            </div> 
        );
    }

    const expSubmissionCloseInstructions = () => {
        return (
            <div className={"explanation"}>
                <p>
                    Close experiment file submission means no more files metadata will be provided to a given experiment. <br/>
                    Having the experiment file submission closed allows its pipeline analysis triggering. <br/>
                </p>
                <p>
                    Mark the checkbox table for every experiment you want to close the file metadata submission.
                    Unmark the checkbox for those experiments you will submit more file metadata.
                </p>
                <p>
                    Press <strong> CLOSE SUBMISSION FOR SELECTED EXPERIMENTS </strong> button to set the marked experiments as closed and ready to be analysed.
                    Otherwise click <strong> SKIP </strong> button.
                </p>
                <p>
                    <strong>Remember:</strong>
                    <ul>
                        <li> You can set any experiment as file submission closed in the experiments view applying <strong> Close File Submission </strong> action. </li>
                        <li> You can upload multiple files for a given experiment if they are FASTQ and paired end.</li>
                        <li> 
                            Our pipeline assumes just one experiment file submission in case of <strong>BAM</strong> or <strong>CRAM</strong> data. <br/>
                            If more files are provided then the analysis will not be done.
                        </li>
                        <li>
                            Analysis pipeline will not work for experiments with multiple file types submission.
                        </li>
                    </ul>
                </p>
            </div>
        );
    }

    const getInstructionsBody = () => {
        switch (typeInstruction){
            case "submitFiles":
                return (fileSubmissionInstructions());
            case "submitExperiments":
                return (experimentSubmissionInstructions());
            case "submissionExperimentClose":
                return (expSubmissionCloseInstructions());
        }
    }


    return (
        <Grid
            direction="row"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item lg={12}>
                <Typography variant={"h6"} align={"center"}> {getDialogTitle()} </Typography>
                {getInstructionsBody()}
            </Grid>
        </Grid>
    ) 

};
